import axios from "axios";
import {notify} from "@kyvg/vue3-notification";

export default {
    namespaced: true,

    state: () => ({
        taskList: [],
        colorList: [],
        recordList: [],
        settingsData: null,
        batteryLevel: 100,
        tasksData: [],
        currentOccurredTask: null,
        availableStrategies: [],
        userTasks: [],
        pendingFeedback: [],
        pendingEvaluation: [],
        analytics: null,
        userStrategies: [],
        batteryTransactions: {
            data: [],
            meta: [],
        },
    }),

    mutations: {
        setTaskList(state, data) {
            state.taskList = data?.data;
        },
        setColorList(state, data) {
            state.colorList = data;
        },
        setRecordList(state, data) {
            state.recordList = data;
        },
        setSettingsData(state, data) {
            state.settingsData = data;
        },
        setCurrentBatteryLevel(state, data) {
            state.batteryLevel = data?.battery ?? 100;
        },
        setCurrentOccurredTask(state, data) {
            state.currentOccurredTask = data?.id ?? null;
        },
        clearCurrentOccurredTask(state) {
            state.currentOccurredTask = null;
        },
        setStrategies(state, data) {
            state.availableStrategies = data;
        },
        clearStrategies(state) {
            state.availableStrategies = [];
        },
        setUserTasks(state, data) {
            state.userTasks = data;
        },
        setPendingFeedbackTasks(state, data) {
            state.pendingFeedback = data;
        },
        setPendingEvaluation(state, data) {
            state.pendingEvaluation = data;
        },
        setAnalytics(state, data) {
            state.analytics = data;
        },
        setUserStrategies(state, data) {
            state.userStrategies = data;
        },
        setBatteryTransactions(state, data) {
            state.batteryTransactions.data = data.data;
            state.batteryTransactions.meta = data.meta;
        },
        clearRecords(state) {
            state.userTasks = [];
        }
    },

    actions: {
        async getTasks({ commit }) {
            await axios.get(`public/mood_tracker/tasks`).then(({ data }) => {
                commit("setTaskList", data);
            });
        },
        async getColors({ commit }) {
            await axios.get(`public/mood_tracker/colors`).then(({ data }) => {
                commit("setColorList", data);
            });
        },
        async getRecords({ commit }) {
            await axios.get(`mood_tracker/list`).then(({ data }) => {
                commit("setRecordList", data);
            });
        },
        async createRecord({ commit }, data) {
            await axios.post(`mood_tracker/create`, data).then(() => {
                notify({
                    title: "Запись сохранена",
                    type: "success",
                });
            });
        },
        async submitFeedback({ commit }, data) {
            await axios.post(`mood_tracker/${data.id}/feedback`, data.form);
        },
        async getCurrentSettings({ commit }) {
            await axios.get(`mood_tracker/settings`).then(({ data }) => {
                commit("setSettingsData", data);
            });
        },
        async setCurrentSettings({ commit }, data) {
            await axios.post(`mood_tracker/set/settings`, {
                mode: data?.mode,
                battery_reset_interval: data?.battery_reset_interval ?? null,
            });
        },
        async getCurrentBatteryLevel({ commit }, mode) {
            await axios.get(`mood_tracker/battery/current`).then(({ data }) => {
                commit("setCurrentBatteryLevel", data);
            });
        },
        async setOccurredTask({ commit }, data) {
            await axios.post(`mood_tracker/set/task/occurred`, data).then(({ data }) => {
                commit("setCurrentOccurredTask", data);
            });
        },
        async setPlannedTask({ commit }, data) {
            await axios.post(`mood_tracker/set/task/planned`, data);
        },
        async changeEmotionOrTask({ commit }, data) {
            await axios.post(`mood_tracker/task/${data.id}/change/state`, data);
        },
        async updateOccurredTaskInterval({ commit }, data) {
            await axios.post(`mood_tracker/task/${data.id}/change/feedback_interval`, data);
        },
        async addStrategyToFavs({ commit }, data) {
            await axios.post(`mood_tracker/strategy/${data.strategy}/save`);
        },
        async hideStrategy({ commit }, data) {
            await axios.post(`mood_tracker/strategy/${data.strategy}/hide`);
        },
        async assignStrategyToTask({ commit }, data) {
            await axios.post(`mood_tracker/set/strategy/${data.strategy_id}/${data.id}`, data);
        },
        async getStrategies({ commit }, data) {
            await axios.post(`mood_tracker/strategy/${data.color_id}`, data).then(({ data }) => {
                commit("setStrategies", data);
            });
        },
        async getAllUserTasks({ commit }, data) {
            await axios.get(`mood_tracker/tasks/current?start_date=${data.start_date}&end_date=${data.end_date ?? ''}`).then(({ data }) => {
                commit("setUserTasks", data);
            });
        },
        async getFeedbackPendingTasks({ commit }) {
            await axios.get(`mood_tracker/tasks/pending_feedback`).then(({ data }) => {
                commit("setPendingFeedbackTasks", data);
            });
        },
        async getPendingEvaluationTasks({ commit }) {
            await axios.get(`mood_tracker/tasks/pending_evaluation`).then(({ data }) => {
                commit("setPendingEvaluation", data);
            });
        },
        async deletePlannedTask({ commit }, data) {
            await axios.delete(`mood_tracker/tasks/planned/${data.id}/delete`);
        },
        async getAnalytics({ commit }) {
            await axios.get(`mood_tracker/analytics`).then(({ data }) => {
                commit("setAnalytics", data);
            });
        },
        async getBatteryTransactions({ commit }, data) {
            await axios.get(`mood_tracker/analytics/battery?page=${data.page}&period=${data.period}`).then(({ data }) => {
                commit("setBatteryTransactions", data);
            });
        },
        async getUserStrategies({ commit }, data) {
            await axios.get('mood_tracker/analytics/strategies').then(({ data }) => {
                commit("setUserStrategies", data);
            });
        },
    }
}
